"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsOnScroll = void 0;
const analyticsOnScroll = (a, itemsTotal) => (_, index) => {
    const percent = (index + 1) / itemsTotal;
    /* eslint-disable no-magic-numbers */
    if (percent >= 0.9)
        a('scroll_90');
    else if (percent >= 0.75)
        a('scroll_75');
    else if (percent >= 0.5)
        a('scroll_50');
    else if (percent >= 0.25)
        a('scroll_25');
    /* eslint-enable no-magic-numbers */
};
exports.analyticsOnScroll = analyticsOnScroll;
